
const initialState = {
    filter: [],
}

export function services(state = initialState, action) {
    switch (action.type) {
        case 'SERVICES_FETCH_SUCCESS':
            return { ...state, availableServices: action.items, allServices: action.items };
        case 'SET_SERVICES_LOADING':
            return { ...state, isServicesLoading: action.isLoading };
        case 'SERVICES_CATEGORIES':
            return { ...state, Categories: action.Categories };
        case 'SERVICES_BENEFITS':
            return { ...state, benefits: action.benefits }
        case 'SERVICES_FIL_BY_CATEGORY':
            return { ...filterSerVices(state, action) };
        case 'SET_SHOW_FIL_SERVICES':
            return { ...state, showFilteredServices: action.showFilteredServices };
        case 'SET_RESERVED_SERVICES':
            return { ...state, reservedServices: action.reservedServices, polarRes: action.polarRes }
        case 'SET_SERVICE_FILTER':
            return { ...state, filter: action.filter }
        case 'SET_SELECTED_DATE':
            return { ...state, selectedDate: action.selectedDate }
        case 'SET_SELECTED_CATEGORY':
            return { ...state, selectedCategory: action.category }

        case 'SET_BOOKING_DETAILS':
            return {
                ...state,
                bookingDetails: action.bookingDetails,
                guestDetails: action.guestDetails,
                guestNames: action.guestName,
                PaymentDetails: action.PaymentDetails,
                bookingCatagory: action.bookingCatagory
            }
        case 'SET_CRUISE_DATE':
            return {
                ...state,
                cruiseStartDate: action.cruiseStartDate,
                cruiseEndDate: action.cruiseEndDate,
                filter: {
                    startDate: action.cruiseStartDate,
                    endDate: action.cruiseEndDate
                }
            }
        case 'SET_SELECTED_SERVICE':
            return { ...state, selectedService: action.selectedService }
        case 'SET_ITINERARIES':
            return { ...state, itineraries: action.itineraries, itineraryMap: action.itineraryMap }
        case 'SET_CONTENT_FEED':
            return { ...state, contentFeedData: action.contentFeedData }
        case 'SET_SELECTED_GUEST_DETAILS':
            return { ...state, selectedGuestDetails: action.selectedGuestDetails }
        case 'SET_CANCELED_SERVICE':
            return { ...state, canceledService: action.canceledService }
        case 'SET_GUEST_PAYER':
            return { ...state, payer: action.payer }
        case 'SET_PAYMENT_LOADER':
            return { ...state, isPayLoading: action.isPayLoading }
        case 'SET_NOTIFICATION_BANNER':
            return { ...state, notification: action.notification }
        case 'SET_AUTH_TOKEN':
            return { ...state, authDetails: action.queryInfo }
        case 'SET_DB_TOKEN':
            return { ...state, dbToken: action.dbTokenObj }
        case 'SET_SCREEN_LOADER':
            return { ...state, isScreenLoading: action.isScreenLoading }
        case 'SET_PAYPAL_INFO':
            return { ...state, payPalPayInfo: action.payPalPayInfo }
        case 'SET_DAYS_CRUISE':
            return { ...state, daysToCruise: action.daysToCruise }
        default:
            return state;
    }
}

const filterSerVices = (state, action) => ({ ...state, availableServices: state.allServices.filter((item) => item.serviceGroup === action.category) });